import React from 'react';
import IconButton, { IconButtonSize, IconButtonVariant } from './IconButton';
import CloseIcon from '../icons/CloseIcon';

interface CloseButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  /** 화면 낭독기가 읽을 이름. 기본 '닫기' */
  ariaLabel?: string;
  /** 어두운 헤더 위에서는 'inverse' */
  variant?: IconButtonVariant;
  size?: IconButtonSize;
  disabled?: boolean;
  style?: React.CSSProperties;
}

const ICON_PX: Record<IconButtonSize, number> = {
  small: 12,
  medium: 14,
  large: 16,
};

/** 다이얼로그·패널·알림의 × 닫기 버튼. */
const CloseButton: React.FC<CloseButtonProps> = ({
  onClick,
  ariaLabel = '닫기',
  variant = 'ghost',
  size = 'medium',
  disabled,
  style,
}) => (
  <IconButton
    icon={<CloseIcon width={ICON_PX[size]} height={ICON_PX[size]} color="currentColor" />}
    ariaLabel={ariaLabel}
    onClick={onClick}
    variant={variant}
    size={size}
    disabled={disabled}
    style={style}
  />
);

export default CloseButton;
